import { getDisplayDate } from "@/domains/messages/factories/create-message-data-model";

type DayDividerProps = {
  date: string;
};

export const DayDivider = ({ date }: DayDividerProps) => {
  return (
    <div className="flex items-center gap-4 py-2">
      <span aria-hidden="true" className="h-px flex-1 bg-line" />

      <span className="rounded-full bg-surface-sunken px-3 py-1 text-sm font-semibold text-content-muted">
        {getDisplayDate(date)}
      </span>

      <span aria-hidden="true" className="h-px flex-1 bg-line" />
    </div>
  );
};
